import {decorateDateString} from "../../utils/decorateDateString";
import {getContentsFromTwitter} from "../../utils/getContentsFromTwitter";
import {addImpression} from "../../utils/addImpression";
import {getContentsFromInstagram} from "../../utils/getContentsFromInstagram";
export function populateSocialMediaBox(entry, container, timelineElement) {
    container.addClass("social_media");
    if (container[0]?.classList.contains("already-loaded")) {
        return;
    } else {
        container?.[0]?.classList.add("already-loaded");
    }
    var clonedBox = $(".social_media_box_prototype").clone().appendTo(container);
    clonedBox.removeClass("social_media_box_prototype");
    clonedBox.removeClass("hidden");
    clonedBox.addClass("social_media_box");
    clonedBox.find(".headline").prepend(entry.description);
    clonedBox.find("input[type=\"hidden\"][name=\"post_id\"]").val(entry.id);
    clonedBox.find(".prost_count").text(entry.sum_prosts);
    clonedBox.find(".comment_count").text(entry.sum_comments);
    clonedBox.find(".js-post-date").text(decorateDateString(timelineElement.post_date));
    clonedBox.find(".author_comment").html(entry.content);
    if (entry.link !== "") {
        if (entry.link.indexOf("instagram.com") >= 0) {
            getContentsFromInstagram(entry.link, entry.type, timelineElement);
        } else if (entry.link.indexOf("facebook.com") >= 0) {
            var embedUrl = entry.link;
            var facebookUrl = "<div class=\"fb-post\" data-href=\"" + embedUrl + "\"" +
                "data-width=\"308\" data-show-text=\"true\"><blockquote cite=\"" + embedUrl + "\"" +
                "class=\"fb-xfbml-parse-ignore\">" + elementLoader + "</blockquote></div>";
            container.find(".content").prepend(facebookUrl);
            container.find(".spinner").hide();
        } else if (entry.link.indexOf("twitter.com") >= 0) {
            getContentsFromTwitter(entry.link, entry.type, timelineElement);
        }
    }
    if (timelineElement !== undefined) {
        addImpression(timelineElement.id);
    }
}